import React from 'react'
import cx from 'classnames'

import { AccordionContext } from 'components/shared/Accordion/context'
import { Icon, ChevronUpIcon } from 'components/shared/Icon/Icon'

const HelpCardChevron = () => {
  const { isOpen } = React.useContext(AccordionContext)

  return (
    <Icon
      className={cx('HelpTraitCard__chevron', {
        'HelpTraitCard__chevron--open': isOpen,
      })}
      icon={ChevronUpIcon}
      size={18}
    />
  )
}

export default HelpCardChevron
